export default __webpack_public_path__ + "static/media/skilljar.ac0102ed.svg";